import { render } from "./CadastrarEvento.vue?vue&type=template&id=66bd05f6&scoped=true"
import script from "./CadastrarEvento.vue?vue&type=script&lang=js"
export * from "./CadastrarEvento.vue?vue&type=script&lang=js"

import "./CadastrarEvento.vue?vue&type=style&index=0&id=66bd05f6&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bd05f6"]])

export default __exports__